export class QuestionCompiled {
  QuestionId: number
  AnswerId: number
  AnswerText: string
}
